"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDraggableItemHelpButtons = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var core_1 = require("@blueprintjs/core");
exports.CustomDraggableItemHelpButtons = (0, mobx_react_1.observer)(function (props) {
    var displayButtons = props.displayButtons, selectedItemHelpButtons = props.selectedItemHelpButtons, source = props.source, draggableId = props.draggableId;
    return (react_1.default.createElement("div", { className: 'buttonsContainer' }, displayButtons &&
        selectedItemHelpButtons &&
        selectedItemHelpButtons.buttons.map(function (button, index) {
            return ((source !== button.destinationId && (react_1.default.createElement(core_1.Button, { small: true, id: "button_".concat(button.destinationId), key: index, text: button.text, icon: button.icon, intent: button.intent || 'none', onClick: function () {
                    if (props.handleHelpButtonClicked) {
                        props.handleHelpButtonClicked(draggableId, source, button.destinationId);
                    }
                } }))) ||
                null);
        })));
});
